<script setup>
import {defineProps} from "vue";

const props = defineProps({
    content: Object,
});
</script>

<template>
    <!-- First item: Level -->
    <div class="items-center rounded bg-slate-100 px-3 py-2 text-center mt-2">
        <h4 class="font-bold leading-tight text-blue-500">{{ props.content.levels_count }}</h4>
        <p class="text-xs text-slate-400">
            {{ $tt('content_card__details_quest_level', props.content.levels_count) }}
        </p>
    </div>

    <!-- Second item: Mission -->
    <div class="items-center rounded bg-slate-100 px-3 py-2 text-center mt-2">
        <h4 class="font-bold leading-tight text-blue-500">{{ props.content.missions_count }}</h4>
        <p class="text-xs text-slate-400">
            {{ $tt('content_card__details_quest_mission', props.content.missions_count) }}
        </p>
    </div>
</template>
